import { ReactiveController, ReactiveControllerHost } from 'lit';

import { State } from './state.ts';
import { StateEvent } from './state-event.ts';
/**
 * A reactive-controller holding a state
 */

type StateCallback = () => void;

export class StateController<T extends State>
implements ReactiveController {
  callback: StateCallback;

  constructor(
    protected host: ReactiveControllerHost,
    private state: T,
    cb?: StateCallback,
  ) {
    this.callback = cb || (() => this.host.requestUpdate());
    this.host.addController(this);
  }

  hostConnected(): void {
    this.state.addEventListener(StateEvent.eventName, this.callback);
    this.callback();
  }
  hostDisconnected(): void {
    this.state.removeEventListener(StateEvent.eventName, this.callback);
  }
}
